"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_track_player_1 = __importStar(require("react-native-track-player"));
const react_redux_1 = require("react-redux");
const constants_1 = require("../../common/constants");
const ChatStreamingText_1 = __importDefault(require("../../component/Chat/ChatStreamingText"));
const VStack_1 = __importDefault(require("../../component/ui-components/VStack"));
const useAppMessage_1 = require("../../hooks/useAppMessage");
const useAudio_1 = require("../../hooks/useAudio");
const user_1 = require("../../store/selectors/user");
const user_2 = require("../../slices/user");
/**
 *
 * @param param0
 * @returns
 */
const VoiceMessage = ({ message, setIsPlaying, isPlaying, index, setActiveMessage, activeMessage, chatMessage, diveDeeper, autoPlay, handleReadAloud, setIsSheetOpen, isSheetOpen, setSelectedText, scrollRef, scrollToMessage, getParentIndex, }) => {
    const voiceSpeedIndex = (0, react_redux_1.useSelector)((state) => state.getUserOptions.voiceSpeed);
    const [rateIndex, setRateIndex] = (0, react_1.useState)(voiceSpeedIndex ?? constants_1.DEFAULT_SPEED_RATE);
    const [streaming, setStreaming] = (0, react_1.useState)(false);
    const selectedVoice = (0, react_redux_1.useSelector)((state) => state.getUserOptions.selectedVoice);
    const conversation = (0, react_redux_1.useSelector)(user_1.selectConversation);
    const selectedCharacter = (0, react_redux_1.useSelector)((state) => state.getUserOptions.characterProfile);
    const storedMessages = (0, react_redux_1.useSelector)((state) => state.getUserOptions.storedMessages);
    const { state } = (0, react_native_track_player_1.usePlaybackState)();
    (0, react_1.useEffect)(() => {
        // if (
        //   state === State.Playing ||
        //   state === State.Buffering ||
        //   state === State.Loading
        // ) {
        //   console.log("Voice playing....");
        //   // if (!isPlaying) setIsPlaying(true);
        // }
        if (state === react_native_track_player_1.State.Ended) {
            // state === State.Paused
            console.log("Stop it....", state);
            setIsPlaying(false);
        }
        // return () => {
        //   try {
        //     if (
        //       state === State.Playing ||
        //       state === State.Buffering ||
        //       state === State.Loading
        //     ) {
        //       console.log("Canceled....");
        //       setIsPlaying(false);
        //       TrackPlayer.pause();
        //     }
        //   } catch (e) {}
        // };
    }, [state]);
    // const checkState = async () => {
    //   const newState = (await getPlaybackState()).state;
    //   if (newState === State.Playing) {
    //     setIsPlaying(true);
    //   } else {
    //     setIsPlaying(false);
    //   }
    // };
    // useEffect(() => {
    //   return () => {
    //     try {
    //       console.log("Canceled one time....");
    //       setIsPlaying(false);
    //       TrackPlayer.pause();
    //     } catch (e) {}
    //   };
    // }, []);
    const handleStop = async () => {
        console.log("Handle stop it...");
        await react_native_track_player_1.default.pause();
        setIsPlaying(false);
        // Tts.stop();
        // setRate(DEFAULT_SPEED_RATE);
    };
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const { getAudioRef, isFileExpired, cacheAudioFile } = (0, useAudio_1.useAudio)();
    const playMessage = (0, react_1.useCallback)(async (message, messageId, speed) => {
        const sourceFileReference = getAudioRef(messageId, speed);
        await react_native_track_player_1.default.reset();
        if (!sourceFileReference.isCached) {
            await cacheAudioFile(sourceFileReference, message, speed);
        }
        await react_native_track_player_1.default.add([{ url: sourceFileReference.url }]);
        react_native_track_player_1.default.play();
    }, []);
    /**
     *
     */
    const handlePlayMessage = (0, react_1.useCallback)(async (message, messageId, speed) => {
        await setIsPlaying(true);
        setStreaming(true);
        await setActiveMessage(index);
        await playMessage(message, messageId, speed);
        setStreaming(false);
    }, [playMessage, rateIndex, voiceSpeedIndex]);
    /**
     *
     * @param message
     */
    const handlePlay = (0, react_1.useCallback)(async (audioMessage, newRateIndex) => {
        console.log("Handle play....", audioMessage, rateIndex, newRateIndex);
        if (isPlaying) {
            react_native_track_player_1.default.reset();
        }
        await setActiveMessage(-1);
        const newSpeedRateIndex = newRateIndex ?? voiceSpeedIndex;
        await handlePlayMessage(audioMessage || message || "", chatMessage?.id.toString() || "", newSpeedRateIndex ?? constants_1.DEFAULT_SPEED_RATE);
    }, [rateIndex, voiceSpeedIndex]);
    const handleVoiceForward = async () => {
        react_native_track_player_1.default.reset();
        let newRateIndex = rateIndex <= constants_1.VOICE_SPEED_LIST.length - 2 ? rateIndex + 1 : 0;
        console.log("new Index freqRate:-", rateIndex, newRateIndex);
        setRateIndex(newRateIndex ?? constants_1.DEFAULT_SPEED_RATE);
        await handlePlay(message, newRateIndex);
        return;
        // await setActiveMessage(-1);
        // await Tts.stop();
        // setTimeout(async () => {
        //   await setIsPlaying(true);
        //   await Tts.getInitStatus().then(
        //     async () => {
        //       await setActiveMessage(index);
        //       await setIsPlaying(true);
        //       Tts.speak(message, {
        //         iosVoiceId: selectedVoice || DEFAULT_VOICE,
        //         rate: freqRate,
        //         androidParams: {
        //           KEY_PARAM_PAN: -1,
        //           KEY_PARAM_VOLUME: DEFAULT_SPEED_RATE,
        //           KEY_PARAM_STREAM: "STREAM_MUSIC",
        //         },
        //       });
        //     },
        //     (err) => {
        //       if (err.code === "no_engine") {
        //         // Tts.requestInstallEngine();
        //       }
        //     }
        //   );
        // }, 100);
    };
    const voiceAutoPlay = (0, react_redux_1.useSelector)((state) => state.getUserOptions.voiceAutoPlay);
    const startVoiceAutoPlay = (0, react_redux_1.useSelector)((state) => state.getUserOptions.startVoiceAutoPlay);
    const dispatch = (0, react_redux_1.useDispatch)();
    const spokenTextEnabled = (0, react_redux_1.useSelector)((state) => state.getUserOptions.messageSpeech);
    (0, react_1.useEffect)(() => {
        if (autoPlay && chatMessage) {
            playMessage(chatMessage.message, chatMessage.id.toString());
        }
    }, [autoPlay, chatMessage]);
    // useEffect(() => { }, [])
    (0, react_1.useLayoutEffect)(() => {
        if (voiceAutoPlay &&
            index === storedMessages?.length &&
            constants_1.AUTOPLAY_MESSAGE_SPEECH &&
            startVoiceAutoPlay &&
            !chatMessage?.isMedia &&
            spokenTextEnabled) {
            // console.log("Auto play last...", selectedCharacter?.journeyId, message);
            handlePlay();
            dispatch((0, user_2.setStartVoiceAutoPlay)(false));
        }
    }, [voiceAutoPlay, spokenTextEnabled, chatMessage?.isMedia, storedMessages]);
    return ((0, jsx_runtime_1.jsx)(VStack_1.default, { children: (0, jsx_runtime_1.jsx)(ChatStreamingText_1.default, { isStreaming: streaming, isPlaying: isPlaying && index === activeMessage, index: index, handlePlay: () => handlePlay(message, rateIndex), handleStop: () => handleStop(), handleVoiceForward: handleVoiceForward, activeMessage: activeMessage, rateIndex: rateIndex, message: message, chatMessage: chatMessage, diveDeeper: diveDeeper, handleReadAloud: handleReadAloud }) }));
};
exports.default = (0, react_1.memo)(VoiceMessage);
